export default __webpack_public_path__ + "static/media/sale.60bc14bb.png";